import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { TripGapsTypes } from '../actions/actions.types'

type TripGapsState = ApplicationState['tripsGaps']

function tripGapsReducer(state: TripGapsState = new ImmutableMap(), action: IAction): TripGapsState {
	switch (action.type) {
		case TripGapsTypes.SetTripGapForSearch:
			return state.set('tripGapForSearch', action.payload.tripGap)
		case TripGapsTypes.GetTripGaps.SUCCESS:
		case TripGapsTypes.ResetTripGaps:
			return new ImmutableMap()
	}
	return state
}

export default tripGapsReducer
